import { useMutation, useQueryClient } from "@tanstack/react-query";
import { researchService } from "../services/research.service";

export const useDeleteChat = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => researchService.deleteChat(id),
    onSuccess: () => {
      // Invalidate chats query to refetch the updated list
      queryClient.invalidateQueries({ queryKey: ["chats"] });
    },
  });
};
